<template>
  <div class="promo-code-input">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label has-icon has-icon-username">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input v-bind:id="field.name" class="form-control" type="text" v-model="field.value" v-bind:name="field.name" debounce="500"/>
        <span class="form-validation-info" v-show="loading">Verifying code...</span>
        <span class="form-validation-error" v-show="!isValid">{{ field.value }} is not a valid promo code</span>
        <span class="form-validation-error" v-show="errorMessage">{{ errorMessage }}</span>
        <span class="form-validation-info" v-show="description">{{ description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoCodeInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          validCode: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true,
      errorMessage: false,
      loading: false,
      description: false
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.errorMessage = false
      this.isValid = true
      this.description = false
      this.field.dirty = true
      this.loading = true
      this.$http.post('public/verify-promo', {code: newVal}).then(({data}, status, request) => {
        if (data.invalid) {
          this.isValid = false
          this.field.validCode = false
        } else if (data.errorMessage) {
          this.errorMessage = data.errorMessage
          this.field.validCode = false
        } else {
          this.description = data.description
          this.field.validCode = true
        }
        this.loading = false
      }).catch(err => {
        this.field.validCode = false
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PromoCodeInput.vue?7b2d8ce8